export default __webpack_public_path__ + "static/media/140G.bfeaaeb2.jpg";